var _path, _rect, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.8C3 5.14903 5.14903 3 7.8 3H24.2C26.851 3 29 5.14903 29 7.8V11H3V7.8Z",
    fill: "#F5DADF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 26,
    height: 26,
    rx: 4,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.2002,
    y1: 11,
    x2: 28.0002,
    y2: 11,
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalendar);
export default __webpack_public_path__ + "static/media/empty-calendar.eb3a914184d06584d00ae7b0de4ad694.svg";
export { ForwardRef as ReactComponent };